import {faMagnifyingGlass} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import * as styles from './tags-popup.scss';

export const searchIcon = <FontAwesomeIcon className={styles.TagsPopup_inputIcon} icon={faMagnifyingGlass} size="sm" />;
